import React from "react";
import "../styles/DevelopmentBanner.css";

const DevelopmentBanner = () => {
  // Create repeating text pattern
  const textPattern = "UNDER CONSTRUCTION • ".repeat(20);

  return (
    <>
      <div className="development-banner-container">
        <div className="development-banner">
          <span className="banner-text">{textPattern}</span>
        </div>
      </div>
      <div className="banner-overlay" />
    </>
  );
};

export default DevelopmentBanner;
